import { FC} from 'react';
import { createUnitMixes } from '../../../fetch/imports';
import { UploadHandler } from '../../../components/import/uploadHandler';

export const ImportUnitMixes: FC = () => {
  return (
  <UploadHandler 
    title='Import Unit Mixes'
    loaderMessage='Importing Unit Mixes ...'
    createEndpoint={createUnitMixes}/>
    )
};